import React, { useEffect, useState } from "react";
import axios from "axios";
import AdminBillView from "./AdminBillView";
import axiosInstance from "../../config/axiosInterceptor";

const statusOptions = [
  { value: "", label: "All" },
  { value: 0, label: "Pending" },
  { value: 1, label: "Approved" },
  { value: 2, label: "Rejected" },
];

const statusColors = {
  0: "#faad14", // Pending - orange
  1: "#52c41a", // Approved - green
  2: "#ff4d4f", // Rejected - red
};

const statusBg = {
  0: "#fffbe6",
  1: "#f6ffed",
  2: "#fff1f0"
};

const BillList = ({ invoiceForType = "bd" }) => {
  const [bills, setBills] = useState([]);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalEntries, setTotalEntries] = useState(0);
  const [filters, setFilters] = useState({ startDate: "", endDate: "", status: "", uniqueId: "" });
  const [viewBill, setViewBill] = useState(null);

  const fetchBills = async () => {
    try {
      
      const params = {
        page,
        limit: perPage,
        ...filters,
        invoiceForType
      };
      // Remove empty uniqueId filter for admin view
      if (!params.uniqueId) delete params.uniqueId;
      const res = await axiosInstance.get(`${process.env.REACT_APP_BASEURL1}/admin/withdrawal/getAllBills`, { params });
      if (res.data.success) {
        setBills(res.data.details);
        setTotalEntries(res.data.totalEntries);
      }
    } catch (error) {
      
    }
  };

  useEffect(() => {
    try {
      fetchBills();
    } catch (error) {
      
    }
    // eslint-disable-next-line
  }, [page, perPage, invoiceForType]);

  const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const handleApply = () => {
    setPage(1);
    fetchBills();
  };

  const handleView = (bill) => {
    setViewBill(bill);
  };

  const handleCloseModal = () => {
    setViewBill(null);
    fetchBills();
  };

  // Animation for modal
  const modalAnim = {
    animation: "fadeInScale 0.3s cubic-bezier(.4,2,.6,1) both"
  };

  return (
    <div style={{
      maxWidth: 1200,
      margin: "40px auto",
      padding: "32px 20px",
      background: "#f6f9fc",
      borderRadius: 18,
      boxShadow: "0 8px 32px #0001",
      minHeight: 600,
      fontFamily: "Inter, Segoe UI, Arial, sans-serif",
      position: "relative"
    }}>
      <style>
        {`
        @keyframes fadeInScale {
          0% { opacity: 0; transform: scale(0.95);}
          100% { opacity: 1; transform: scale(1);}
        }
        .admin-bill-row:hover {
          background: #f0f5ff !important;
          transition: background 0.2s;
        }
        .admin-bill-btn {
          background: #1677ff;
          color: #fff;
          border: none;
          border-radius: 5px;
          padding: 6px 18px;
          font-size: 15px;
          font-weight: 500;
          cursor: pointer;
          transition: background 0.2s, box-shadow 0.2s;
          box-shadow: 0 2px 8px #1677ff22;
        }
        .admin-bill-btn:hover {
          background: #0958d9;
        }
        `}
      </style>
      <h2 style={{
        textAlign: "center",
        fontWeight: 700,
        fontSize: 32,
        letterSpacing: 1,
        marginBottom: 18,
        color: "#222"
      }}>
        {invoiceForType === "bd" ? "BD Bills" : "Agency Bills"}
      </h2>
      <div style={{
        display: "flex",
        gap: 16,
        marginBottom: 20,
        alignItems: "center",
        flexWrap: "wrap"
      }}>
        <input
          type="date"
          name="startDate"
          value={filters.startDate}
          onChange={handleFilterChange}
          style={{
            padding: "7px 12px",
            border: "1px solid #d9d9d9",
            borderRadius: 6,
            fontSize: 15,
            background: "#fff"
          }}
        />
        <input
          type="date"
          name="endDate"
          value={filters.endDate}
          onChange={handleFilterChange}
          style={{
            padding: "7px 12px",
            border: "1px solid #d9d9d9",
            borderRadius: 6,
            fontSize: 15,
            background: "#fff"
          }}
        />
        <input
          type="text"
          name="uniqueId"
          placeholder={invoiceForType === "bd" ? "BD Unique ID" : "Agency Unique ID"}
          value={filters.uniqueId}
          onChange={handleFilterChange}
          style={{
            padding: "7px 12px",
            border: "1px solid #d9d9d9",
            borderRadius: 6,
            fontSize: 15,
            background: "#fff"
          }}
        />
        <select
          name="status"
          value={filters.status}
          onChange={handleFilterChange}
          style={{
            padding: "7px 12px",
            border: "1px solid #d9d9d9",
            borderRadius: 6,
            fontSize: 15,
            background: "#fff"
          }}
        >
          {statusOptions.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
        </select>
        <button
          className="admin-bill-btn"
          style={{ padding: "7px 28px", fontSize: 16 }}
          onClick={handleApply}
        >
          Apply
        </button>
      </div>
      <div style={{
        overflowX: "auto",
        borderRadius: 10,
        boxShadow: "0 2px 12px #0001",
        background: "#fff"
      }}>
        <table style={{
          width: "100%",
          borderCollapse: "separate",
          borderSpacing: 0,
          fontSize: 16,
          minWidth: 1000
        }}>
          <thead>
            <tr style={{
              background: "#f0f5ff",
              color: "#222",
              fontWeight: 600
            }}>
              <th style={{ padding: 12, borderBottom: "2px solid #e6f4ff" }}>S.No</th>
              <th style={{ padding: 12, borderBottom: "2px solid #e6f4ff" }}>{invoiceForType === "bd" ? "BD" : "Agency"}</th>
              <th style={{ padding: 12, borderBottom: "2px solid #e6f4ff" }}>Start Date</th>
              <th style={{ padding: 12, borderBottom: "2px solid #e6f4ff" }}>End Date</th>
              <th style={{ padding: 12, borderBottom: "2px solid #e6f4ff" }}>Created At</th>
              <th style={{ padding: 12, borderBottom: "2px solid #e6f4ff" }}>Status</th>
              <th style={{ padding: 12, borderBottom: "2px solid #e6f4ff" }}>View</th>
            </tr>
          </thead>
          <tbody>
            {bills.map((bill, idx) => (
              <tr
                key={bill._id}
                className="admin-bill-row"
                style={{
                  background: idx % 2 === 0 ? "#fafcff" : "#f6f9fc",
                  transition: "background 0.2s"
                }}
              >
                <td style={{ padding: 10, textAlign: "center" }}>{(page - 1) * perPage + idx + 1}</td>
                <td style={{ padding: 10, textAlign: "center" }}>{bill.uniqueId}</td>
                <td style={{ padding: 10, textAlign: "center" }}>{bill.startDate ? new Date(bill.startDate).toLocaleDateString() : "-"}</td>
                <td style={{ padding: 10, textAlign: "center" }}>{bill.endDate ? new Date(bill.endDate).toLocaleDateString() : "-"}</td>
                <td style={{ padding: 10, textAlign: "center" }}>{bill.createdAt ? new Date(bill.createdAt).toLocaleString() : "-"}</td>
                <td style={{
                  padding: 10,
                  textAlign: "center",
                  color: statusColors[bill.approved],
                  background: statusBg[bill.approved],
                  fontWeight: 600,
                  letterSpacing: 1,
                  borderRadius: 6
                }}>
                  {bill.approved === 0 ? "Pending" : bill.approved === 1 ? "Approved" : "Rejected"}
                </td>
                <td style={{ padding: 10, textAlign: "center" }}>
                  {bill.billPath ? (
                    <a
                      href={`${process.env.REACT_APP_BASEURL1}/${bill.billPath}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="admin-bill-btn"
                      style={{
                        background: "#13c2c2",
                        boxShadow: "0 2px 8px #13c2c244",
                        color: "#fff",
                        padding: "6px 18px",
                        borderRadius: 6,
                        fontWeight: 600,
                        textDecoration: "none"
                      }}
                    >
                      View
                    </a>
                  ) : (
                    <span style={{ color: "#aaa" }}>-</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginTop: 24,
        flexWrap: "wrap",
        gap: 10
      }}>
        <div>
          <button
            className="admin-bill-btn"
            style={{
              background: page === 1 ? "#d9d9d9" : "#1677ff",
              color: page === 1 ? "#888" : "#fff",
              cursor: page === 1 ? "not-allowed" : "pointer",
              marginRight: 8
            }}
            disabled={page === 1}
            onClick={() => setPage(page - 1)}
          >
            Prev
          </button>
          <button
            className="admin-bill-btn"
            style={{
              background: page * perPage >= totalEntries ? "#d9d9d9" : "#1677ff",
              color: page * perPage >= totalEntries ? "#888" : "#fff",
              cursor: page * perPage >= totalEntries ? "not-allowed" : "pointer"
            }}
            disabled={page * perPage >= totalEntries}
            onClick={() => setPage(page + 1)}
          >
            Next
          </button>
        </div>
        <span style={{ fontSize: 16 }}>
          Page <b>{page}</b> of <b>{Math.ceil(totalEntries / perPage) || 1}</b>
        </span>
        <span style={{ fontSize: 16 }}>
          Entries per page:&nbsp;
          <select
            value={perPage}
            onChange={e => { setPerPage(Number(e.target.value)); setPage(1); }}
            style={{
              padding: "5px 12px",
              border: "1px solid #d9d9d9",
              borderRadius: 5,
              fontSize: 15,
              background: "#fff"
            }}
          >
            {[10, 20, 50].map(n => <option key={n} value={n}>{n}</option>)}
          </select>
        </span>
        <span style={{ fontSize: 16 }}>
          Total Entries: <b>{totalEntries}</b>
        </span>
      </div>

      {/* Modal for AdminBillView removed, now View opens PDF in new tab */}
    </div>
  );
};

export default BillList;